import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import {
    FAILURE_CUSTOMER_DATA,
    FAILURE_CUSTOMER_FEEDBACK,
    FAILURE_CUSTOMER_MAIL_ADDRESSES,
    FAILURE_CUSTOMER_PHONE_NUMBERS,
    REQUEST_CUSTOMER_DATA,
    REQUEST_CUSTOMER_FEEDBACK,
    REQUEST_CUSTOMER_MAIL_ADDRESSES,
    REQUEST_CUSTOMER_PHONE_NUMBERS,
    SUCCESS_CUSTOMER_DATA,
    SUCCESS_CUSTOMER_FEEDBACK,
    SUCCESS_CUSTOMER_MAIL_ADDRESSES,
    SUCCESS_CUSTOMER_PHONE_NUMBERS,
} from './actions';

/* Customer Mail Adresses */
export function customerMailAddressReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_MAIL_ADDRESSES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_MAIL_ADDRESSES: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_MAIL_ADDRESSES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Customer Phone Numbers */
export function customerPhoneNumberReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CUSTOMER_PHONE_NUMBERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_PHONE_NUMBERS: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_PHONE_NUMBERS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

/* Customer Data */
export function customerDataReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_CUSTOMER_DATA:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_DATA: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_DATA:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

/* Customer Feedback */
export function customerFeedbackReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_CUSTOMER_FEEDBACK:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CUSTOMER_FEEDBACK: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CUSTOMER_FEEDBACK:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
